import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter/EqualsType';
import { UserId } from '../UserId';

export const User = struct({
	equalsType: EqualsType,
	values: array(UserId),
});
